<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event"></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <!--Content-->
        <div class="content" [class.loading]="isLoading">
            <div class="assets" *ngIf="!table.isEmpty; else emptyState">
                <!--show table if there are any assets-->
                <app-table [table]="table"></app-table>
            </div>

            <ng-template #emptyState>
                <!--empty state-->
                <div class="ui segment">
                    <app-empty-state
                        class="empty-state"
                        label="{{ 'company.assets.noAssetsFound' | translate }}"
                    ></app-empty-state>
                </div>
            </ng-template>
        </div>
    </div>
</div>
